import React, { useEffect } from 'react';
import '../styles/LegalPages.css';

export default function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">Terms & Conditions</h1>
          <p className="legal-date">Last Updated: January 26, 2026</p>
        </div>
        <div className="legal-content" style={{ opacity: 0, animation: 'fadeUp 0.8s ease forwards' }}>
          <p>This document governs the use of cvearity.com and all associated services, and all services made available through the cvearity.com website (collectively referred to as the "Services").</p>

          <h2>1. Definitions</h2>
          <ul>
            <li><strong>"CVEarity" / "Company"</strong> refers to Cybertix, the legal entity owning and operating the CVEarity platform.</li>
            <li><strong>"User" / "You"</strong> refers to any individual, organization, or legal entity accessing or using the Services.</li>
            <li><strong>"Platform"</strong> means the CVEarity website, lookup services, APIs, dashboards, and systems.</li>
            <li><strong>"Data Sources"</strong> include public, open-source, governmental, commercial, and third-party databases such as NVD, MITRE, vendor advisories, and public repositories.</li>
            <li><strong>"Lookup"</strong> refers to the CVE, vendor, and product search functionality available on cvearity.com.</li>
          </ul>

          <h2>2. Acceptance of Terms</h2>
          <p>By accessing, browsing, searching, querying, registering, or using any part of the Platform, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions and the Privacy Policy. If you do not agree, you must not access or use the Services.</p>

          <h2>3. Scope of Services</h2>
          <ul>
            <li>CVEarity provides publicly accessible CVE, vendor, and product vulnerability information through the cvearity.com website.</li>
            <li>The information is intended solely for informational, security research, awareness, and defensive cybersecurity purposes only.</li>
          </ul>

          <h2>4. Nature of Information & Disclaimer</h2>
          <h3>4.1</h3>
          <p>CVEarity aggregates, processes, enriches, and correlates data obtained from external public and third-party sources.</p>

          <h3>4.2 CVEarity does not guarantee:</h3>
          <ul>
            <li>Accuracy</li>
            <li>Completeness</li>
            <li>Timeliness</li>
            <li>Non-infringement</li>
            <li>Reliability</li>
            <li>Availability</li>
          </ul>

          <h3>4.3</h3>
          <p>CVE data, vendor data, exploit data, and risk scores are provided "as-is" and "as-available".</p>

          <h3>4.4</h3>
          <p>CVEarity is not a vulnerability authority and does not replace official advisories from vendors, CERTs, NVD, or regulatory bodies.</p>

          <h3>4.5 The Platform does not constitute:</h3>
          <ul>
            <li>Legal advice</li>
            <li>Compliance certification</li>
            <li>Risk acceptance guidance</li>
            <li>Security guarantees</li>
          </ul>

          <h2>5. Acceptable Use Policy</h2>
          <h3>Users shall not:</h3>
          <ul>
            <li>Use the Platform for unlawful purposes</li>
            <li>Attempt unauthorized access to systems</li>
            <li>Perform scraping, crawling, or automated extraction without written permission</li>
            <li>Reverse engineer or replicate services</li>
            <li>Distribute malicious payloads or exploit code</li>
            <li>Misuse data for offensive cyber operations</li>
            <li>Misrepresent CVEarity data</li>
            <li>Use services for surveillance, harassment, or tracking</li>
          </ul>

          <h2>6. Use of CVE, Vendor, and Product Information</h2>
          <h3>6.1</h3>
          <p>Information available on cvearity.com is provided for security research, awareness, risk understanding, and defensive use only.</p>

          <h3>6.2</h3>
          <p>CVEarity does not guarantee that displayed information is complete, accurate, or up to date.</p>

          <h3>6.3</h3>
          <p>Automated querying, scraping, bulk extraction, or systematic data harvesting is strictly prohibited without prior written authorization.</p>

          <h2>7. Intellectual Property</h2>
          <p>All platform architecture, code, databases, algorithms, workflows, UI/UX, branding, and original content are the exclusive intellectual property of CVEarity. Users receive a limited, non-exclusive, non-transferable, revocable license to use the Services.</p>

          <h2>8. Third-Party Data & Attribution</h2>
          <p>CVEarity integrates data from multiple external sources including open databases and public repositories. CVEarity does not claim ownership of third-party data and complies with applicable attribution and licensing obligations.</p>

          <h2>9. Limitation of Liability</h2>
          <h3>To the maximum extent permitted by law, CVEarity shall not be liable for:</h3>
          <ul>
            <li>Direct or indirect damages</li>
            <li>Data loss</li>
            <li>Business interruption</li>
            <li>Security incidents</li>
            <li>Financial loss</li>
            <li>Compliance failures</li>
            <li>Misinterpretation of data</li>
          </ul>
          <p>Use of the Platform is entirely at the user's risk.</p>

          <h2>10. Indemnification</h2>
          <p>Users agree to indemnify and hold harmless CVEarity, its directors, employees, partners, and affiliates from any claims, liabilities, damages, or legal actions arising from misuse of the Platform or violation of these Terms.</p>

          <h2>11. Service Availability</h2>
          <h3>CVEarity reserves the right to:</h3>
          <ul>
            <li>Modify services</li>
            <li>Suspend services</li>
            <li>Discontinue services</li>
            <li>Restrict access</li>
            <li>Limit usage</li>
          </ul>
          <p>Without prior notice.</p>

          <h2>12. Termination</h2>
          <p>CVEarity may terminate or suspend access at its sole discretion for any violation of these Terms.</p>

          <h2>13. Jurisdiction & Governing Law</h2>
          <p>These Terms shall be governed by and construed in accordance with the laws of India.</p>
          <p><strong>Exclusive Jurisdiction:</strong> All disputes, claims, or legal proceedings shall be subject to the exclusive jurisdiction of the competent courts in Mumbai, Maharashtra, India.</p>

          <h2>14. Amendments</h2>
          <p>CVEarity reserves the right to update these Terms at any time. Continued use of the Platform constitutes acceptance of revised Terms.</p>

          <h2>Contact Information</h2>
          <p>
            <strong>Entity Name:</strong> Cybertix<br />
            <strong>Product:</strong> CVEarity<br />
            <strong>Email:</strong> legal@cvearity.com<br />
            <strong>Website:</strong> cvearity.com
          </p>

          <p style={{ marginTop: '3rem' }}>Effective Date: January 26, 2026</p>
        </div>
      </div>
    </main>
  );
}
